export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=editorial%20newsroom%20magazine%20cover%20background%2C%20collage%20of%20newspaper%20clippings%20and%20headlines%20with%20warm%20beige%20paper%20texture%2C%20subtle%20ink%20splashes%20and%20red%20accents%2C%20modern%20minimal%20flat%20design%2C%20soft%20ambient%20light&width=1600&height=1000&seq=hero-bg-41&orientation=landscape"
          alt="四一爆料历史合集与时间线"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/75"></div>
      </div>

      <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-6 w-full pt-32 md:pt-40 pb-20 md:pb-28">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs font-medium tracking-widest whitespace-nowrap">
          <i className="ri-fire-line text-accent-300"></i>
          热点脉络 · 系列合集 · 时间线归档
        </span>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight md:leading-tight mt-6 max-w-3xl">
          补课错过的瓜料，从时间线开始翻
        </h1>

        <p className="mt-6 text-background-100/90 text-base md:text-lg leading-relaxed max-w-2xl">
          四一爆料把往期系列与热点话题，按事件顺序系统性归档整理。无论你想回看一条完整脉络，还是补课曾经错过的内容，都能在这里快速找到对应时间节点。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
          <a
            href="#timeline"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 hover:bg-accent-600 text-foreground-950 text-sm font-bold whitespace-nowrap transition-colors"
          >
            浏览历史时间线
            <i className="ri-arrow-right-down-line text-base"></i>
          </a>
          <a
            href="#series"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 text-sm font-semibold whitespace-nowrap transition-colors"
          >
            查看往期合集
          </a>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-2xl">
          {[
            { n: "200+", l: "收录时间节点" },
            { n: "6 大", l: "常设内容系列" },
            { n: "3 年", l: "跨年度脉络" },
            { n: "100%", l: "按顺序整理" },
          ].map((s) => (
            <div
              key={s.l}
              className="rounded-xl bg-background-50/10 border border-background-50/20 px-4 py-4 text-center"
            >
              <p className="font-heading text-xl md:text-2xl font-black text-accent-300">{s.n}</p>
              <p className="mt-1 text-background-100/80 text-xs">{s.l}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}